import { alertActions } from ".";
import { dashboardImageConstants } from "../constants/dashboardImageConstants";
import { dashboardImageService } from "../services/dashboardImageService";

export const dashboardImageActions = {
  loadingData,
  fetchDashboardImage,
};
function fetchDashboardImage(obj) {
  return (dispatch) => {
    dispatch(request());
    dashboardImageService.fetchDashboardImage(obj).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dashboardImageConstants.GETALL_REQUEST };
  }
  function success(data) {
    return { type: dashboardImageConstants.GETALL_SUCCESS, data };
  }
  function failure(error) {
    return { type: dashboardImageConstants.GETALL_FAILURE, error };
  }
}

function loadingData(isbool) {
  return {
    type: dashboardImageConstants.LOADING_REQUEST,
    isbool,
  };
}
